import React, { useState } from 'react';
import FilterPopover from "../FilterPopover";
import { Checkbox, Divider, Form } from "antd";
import { FormattedMessage } from "react-intl";
import { Button } from "ui";

interface AudienceStatusFilterProps {
    tagBuilder: Function;
    form: any;
    filterKey: string;
    setFilterKey: React.Dispatch<React.SetStateAction<string>>;
}

const AudienceStatusFilter: React.FC<AudienceStatusFilterProps> = ({
    filterKey,
    setFilterKey,
    form,
    tagBuilder,
}) => {
    const [initialValues, setInitialValues] = useState(undefined);
    const key = 'audience-status';

    const content = (
        <div className={'flex flex-column p-1 checkbox-wrapper'}>
            <div className={'bold'}>
                <FormattedMessage id={'general.active'} />
            </div>
            <Form.Item name={'audienceStatus'}>
                <Checkbox.Group className={'flex'}>
                    <Checkbox value="ONLINE"><FormattedMessage id='general.yes' /></Checkbox>
                    <Checkbox value="OFFLINE"><FormattedMessage id='general.no' /></Checkbox>
                </Checkbox.Group>
            </Form.Item>

            <Divider className={'m-2'} />

            <div className={'flex justify-between p-1'}>
                <Button type={'link'} onClick={() => handleClose()} message='general.cancel' />
                <Button type={'primary'} onClick={() => handleOpen(false)} message='general.select' />
            </div>
        </div>
    );

    const handleClose = () => {
        form.setFieldsValue(initialValues);
        setFilterKey('');
    };

    const handleOpen = (open: boolean) => {
        if (open) {
            setInitialValues(form.getFieldsValue());
        } else {
            tagBuilder();
            setFilterKey('');
        }
    };

    return (
        <FilterPopover
            popoverKey={key}
            filterKey={filterKey}
            setOpen={setFilterKey}
            placement={'bottomLeft'}
            handleOpen={handleOpen}
            content={content}
            title={'general.status'}
            buttonTitle={'general.status'}
        />
    );
};

export default AudienceStatusFilter;